import React from 'react';
import CustomNavbar from './components/Navbar';
import MainPage from './components/Main';
import './App.css';
import TrustUs from './components/Trust';
import TransportEurope from './components/TransportEurope';
import StatsPage from './components/Stats';
import OpinionsPage from './components/Reviews';
import ContactUs from './components/Contact';
import Footer from './components/Footer';
import { LanguageProvider } from './components/LanguageContext';

const App: React.FC = () => {
  return (
    <LanguageProvider>
      <div>
        <CustomNavbar />
        <MainPage />
        <TrustUs />
        <StatsPage />
        <TransportEurope />
        <OpinionsPage />
        <ContactUs />
        <Footer />
      </div>
    </LanguageProvider>
  );
};

export default App;
